import React from 'react';
import { StarIcon, CheckCircleIcon } from 'lucide-react';
import { WebinarLink } from './WebinarLink';
export const Reviews = ({
  openModal
}) => {
  // Replace 'webinar' with WebinarLink component in text
  const replaceWebinarWithLink = text => {
    const parts = text.split(/(\bwebinar\b)/i);
    return parts.map((part, index) => {
      if (part.toLowerCase() === 'webinar') {
        return <WebinarLink key={index} onClick={openModal} data-id="element-184">
            webinar
          </WebinarLink>;
      }
      return part;
    });
  };
  // Helper function to render stars based on rating
  const renderStars = rating => {
    const stars = [];
    for (let i = 0; i < 5; i++) {
      stars.push(<StarIcon key={i} className={`w-5 h-5 ${i < rating ? 'text-green-500 fill-green-500' : 'text-gray-200'}`} data-id="element-185" />);
    }
    return <div className="flex" data-id="element-186">{stars}</div>;
  };
  return <section className="mb-10" data-id="element-187">
      <h2 className="text-xl font-bold text-blue-800 mb-6" data-id="element-188">
        Wat deelnemers zeggen over het {replaceWebinarWithLink('webinar')}
      </h2>
      <div className="space-y-8" data-id="element-189">
        {/* R.Bosma's Review */}
        <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-190">
          <div className="bg-gray-50 p-4 flex items-center justify-between" data-id="element-191">
            <div className="flex items-center" data-id="element-192">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2oWBifrk1zfqZg5zYRSTen/Ontwerp_zonder_titel_%2845%29.png" alt="R.Bosma profile" className="w-10 h-10 rounded-full object-cover mr-3" data-id="element-193" />
              <div data-id="element-194">
                <div className="flex items-center" data-id="element-195">
                  <h3 className="font-bold mr-2" data-id="element-196">R.Bosma</h3>
                  <span className="text-sm text-gray-500" data-id="element-197">3 reviews</span>
                  <span className="mx-2 text-gray-400" data-id="element-198">•</span>
                  <span className="text-sm text-gray-500" data-id="element-199">NL</span>
                </div>
                <div className="flex items-center" data-id="element-200">
                  {renderStars(5)}
                  <div className="ml-2 flex items-center text-gray-500 text-sm" data-id="element-201">
                    <CheckCircleIcon className="w-4 h-4 mr-1" data-id="element-202" />
                    Geverifieerd
                  </div>
                </div>
              </div>
            </div>
            <div className="text-gray-500" data-id="element-203">21 mei 2025</div>
          </div>
          <div className="p-4" data-id="element-204">
            <h4 className="font-bold text-lg mb-2" data-id="element-205">
              Hele fijne {replaceWebinarWithLink('webinar')}
            </h4>
            <p className="leading-relaxed mb-3" data-id="element-206">
              Ik had al veel hondentrainingen gevolgd en certificaten gehaald,
              maar toch kreeg mijn hond gedragsproblemen, zoals uitvallen en
              niet goed luisteren. Dat frustreerde me, want ik wist niet goed
              wat ik verkeerd deed. Ik ben begonnen met 'Liefdevol communiceren'
              en dit heeft echt een verschil gemaakt.
            </p>
            <p className="leading-relaxed" data-id="element-207">
              Ik begrijp nu veel beter wat mijn hond wél en niet snapt, en
              daardoor kan ik veel duidelijker en consequenter zijn. Mijn
              zelfvertrouwen is gegroeid en ik voel me rustiger in het contact
              met mijn hond. Hierdoor vertrouwt mijn hond ook meer op mij. De
              samenwerking is veel prettiger geworden – ik weet wat ik doe en
              waarom het werkt. Dat geeft rust, voor mij én voor mijn inmiddels
              honden.
            </p>
            <p className="text-right text-sm text-gray-500 mt-2" data-id="element-208">
              30 april 2025
            </p>
          </div>
        </div>
        {/* Winok's Review */}
        <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-209">
          <div className="bg-gray-50 p-4 flex items-center justify-between" data-id="element-210">
            <div className="flex items-center" data-id="element-211">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/4qKke9UKsqE4XLCzHK99xw/73x73_%284%29.png" alt="Winok profile" className="w-10 h-10 rounded-full object-cover mr-3" data-id="element-212" />
              <div data-id="element-213">
                <div className="flex items-center" data-id="element-214">
                  <h3 className="font-bold mr-2" data-id="element-215">Winok</h3>
                  <span className="text-sm text-gray-500" data-id="element-216">1 review</span>
                  <span className="mx-2 text-gray-400" data-id="element-217">•</span>
                  <span className="text-sm text-gray-500" data-id="element-218">BE</span>
                </div>
                <div className="flex items-center" data-id="element-219">
                  {renderStars(5)}
                  <div className="ml-2 flex items-center text-gray-500 text-sm" data-id="element-220">
                    <CheckCircleIcon className="w-4 h-4 mr-1" data-id="element-221" />
                    Geverifieerd
                  </div>
                </div>
              </div>
            </div>
            <div className="text-gray-500" data-id="element-222">3 okt 2024</div>
          </div>
          <div className="p-4" data-id="element-223">
            <h4 className="font-bold text-lg mb-2" data-id="element-224">
              Fijne manier om met honden om te gaan.
            </h4>
            <p className="leading-relaxed" data-id="element-225">
              Fijne manier om met honden om te gaan.. ik heb een
              hondenuitlaatservice en wandel stressless met vijf honden... geeft
              rust voor zowel de honden als mezelf. Drie meter lijn werkt prima
              met meerdere honden of zoals door Amee geleerd
            </p>
            <p className="text-right text-sm text-gray-500 mt-2" data-id="element-226">
              28 september 2024
            </p>
          </div>
        </div>
        {/* Margreet's Review */}
        <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-227">
          <div className="bg-gray-50 p-4 flex items-center justify-between" data-id="element-228">
            <div className="flex items-center" data-id="element-229">
              <div className="w-10 h-10 rounded-full bg-red-100 flex items-center justify-center text-gray-700 font-bold mr-3" data-id="element-230">
                MA
              </div>
              <div data-id="element-231">
                <div className="flex items-center" data-id="element-232">
                  <h3 className="font-bold mr-2" data-id="element-233">Margreet</h3>
                  <span className="text-sm text-gray-500" data-id="element-234">4 reviews</span>
                  <span className="mx-2 text-gray-400" data-id="element-235">•</span>
                  <span className="text-sm text-gray-500" data-id="element-236">NL</span>
                </div>
                {renderStars(5)}
              </div>
            </div>
            <div className="text-gray-500" data-id="element-237">20 apr 2024</div>
          </div>
          <div className="p-4" data-id="element-238">
            <h4 className="font-bold text-lg mb-2" data-id="element-239">
              Dit was de eerste keer dat ik een...
            </h4>
            <p className="leading-relaxed" data-id="element-240">
              Dit was de eerste keer dat ik een online hondencursus volgde en ik
              heb er veel van opgestoken. Hoewel mijn honden zich (meestal)
              prima gedragen, wilde ik vooral leren wat ik zelf nog een beter
              kan doen ivm de communicatie. Dat is gelukt, het valt echt op dat
              omdat ik mij zelf anders opstel, mijn honden nu veel rustiger
              communiceren met andere honden. Vooral met onbekende honden was er
              toch vaak wel flink geblaf. Nu bijna niet meer, heerlijk, wat is
              wandelen toch/weer een genot. Idd: stressless!
            </p>
          </div>
        </div>
        {/* René de Jong Review */}
        <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-241">
          <div className="bg-gray-50 p-4 flex items-center justify-between" data-id="element-242">
            <div className="flex items-center" data-id="element-243">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/eXGLUSGB8WpmCCqjk27tjh/73x73_%283%29.png" alt="René de Jong profile" className="w-10 h-10 rounded-full object-cover mr-3" data-id="element-244" />
              <div data-id="element-245">
                <div className="flex items-center" data-id="element-246">
                  <h3 className="font-bold mr-2" data-id="element-247">René de Jong</h3>
                  <span className="text-sm text-gray-500" data-id="element-248">6 reviews</span>
                  <span className="mx-2 text-gray-400" data-id="element-249">•</span>
                  <span className="text-sm text-gray-500" data-id="element-250">NL</span>
                </div>
                <div className="flex items-center" data-id="element-251">
                  {renderStars(5)}
                  <div className="ml-2 flex items-center text-gray-500 text-sm" data-id="element-252">
                    <CheckCircleIcon className="w-4 h-4 mr-1" data-id="element-253" />
                    Geverifieerd
                  </div>
                </div>
              </div>
            </div>
            <div className="text-gray-500" data-id="element-254">14 mrt 2024</div>
          </div>
          <div className="p-4" data-id="element-255">
            <h4 className="font-bold text-lg mb-2" data-id="element-256">Het werkt echt</h4>
            <p className="leading-relaxed" data-id="element-257">
              We hebben het gevoel dat wij zelf de hondentaal beter begrijpen of
              zoals in de cursus geleerd: de honden beter kunnen "lezen".
              Aanrader het werkt echt.
            </p>
            <p className="text-right text-sm text-gray-500 mt-2" data-id="element-258">
              22 februari 2024
            </p>
          </div>
        </div>
        {/* Gerard Dekkers Review */}
        <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-259">
          <div className="bg-gray-50 p-4 flex items-center justify-between" data-id="element-260">
            <div className="flex items-center" data-id="element-261">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/fQqJmPyJGyoub8Zq1U3aDc/73x73_%282%29.png" alt="Gerard Dekkers profile" className="w-10 h-10 rounded-full object-cover mr-3" data-id="element-262" />
              <div data-id="element-263">
                <div className="flex items-center" data-id="element-264">
                  <h3 className="font-bold mr-2" data-id="element-265">Gerard Dekkers</h3>
                  <span className="text-sm text-gray-500" data-id="element-266">2 reviews</span>
                  <span className="mx-2 text-gray-400" data-id="element-267">•</span>
                  <span className="text-sm text-gray-500" data-id="element-268">NL</span>
                </div>
                {renderStars(4)}
              </div>
            </div>
            <div className="text-gray-500" data-id="element-269">20 apr 2025</div>
          </div>
          <div className="p-4" data-id="element-270">
            <h4 className="font-bold text-lg mb-2" data-id="element-271">
              Goede online {replaceWebinarWithLink('webinar')} met heldere
              uitleg
            </h4>
            <p className="text-right text-sm text-gray-500 mt-2" data-id="element-272">
              22 maart 2025
            </p>
          </div>
        </div>
        {/* Blije hondenbaas Review */}
        <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-273">
          <div className="bg-gray-50 p-4 flex items-center justify-between" data-id="element-274">
            <div className="flex items-center" data-id="element-275">
              <div className="w-10 h-10 rounded-full bg-orange-100 flex items-center justify-center text-gray-700 font-bold mr-3" data-id="element-276">
                BH
              </div>
              <div data-id="element-277">
                <div className="flex items-center" data-id="element-278">
                  <h3 className="font-bold mr-2" data-id="element-279">Blije hondenbaas</h3>
                  <span className="text-sm text-gray-500" data-id="element-280">1 review</span>
                  <span className="mx-2 text-gray-400" data-id="element-281">•</span>
                  <span className="text-sm text-gray-500" data-id="element-282">NL</span>
                </div>
                {renderStars(4)}
              </div>
            </div>
            <div className="text-gray-500" data-id="element-283">9 aug 2025</div>
          </div>
          <div className="p-4" data-id="element-284">
            <h4 className="font-bold text-lg mb-2" data-id="element-285">
              We merkten meteen verschil
            </h4>
            <p className="leading-relaxed" data-id="element-286">
              We merkten meteen verschil bij onze hond, na toepassen van een
              aantal vaardigheden. Wij begrijpen haar beter en zij begrijpt ons
              beter. Er is veel meer rust in haar gedrag en we hebben nog meer
              plezier in de omgang met haar. Bedankt, stressless dogs en Amee!
            </p>
            <p className="text-right text-sm text-gray-500 mt-2" data-id="element-287">
              25 juli 2025
            </p>
          </div>
        </div>
        {/* Tine's Review */}
        <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-288">
          <div className="bg-gray-50 p-4 flex items-center justify-between" data-id="element-289">
            <div className="flex items-center" data-id="element-290">
              <div className="w-10 h-10 rounded-full bg-yellow-100 flex items-center justify-center text-gray-700 font-bold mr-3" data-id="element-291">
                TI
              </div>
              <div data-id="element-292">
                <div className="flex items-center" data-id="element-293">
                  <h3 className="font-bold mr-2" data-id="element-294">Tine</h3>
                  <span className="text-sm text-gray-500" data-id="element-295">4 reviews</span>
                  <span className="mx-2 text-gray-400" data-id="element-296">•</span>
                  <span className="text-sm text-gray-500" data-id="element-297">BE</span>
                </div>
                {renderStars(5)}
              </div>
            </div>
            <div className="text-gray-500" data-id="element-298">3 sep 2024</div>
          </div>
          <div className="p-4" data-id="element-299">
            <h4 className="font-bold text-lg mb-2" data-id="element-300">
              Niet goed maar uitstekend
            </h4>
            <p className="leading-relaxed mb-3" data-id="element-301">Niet goed maar uitstekend!</p>
            <p className="leading-relaxed" data-id="element-302">
              Amée is een zeer lieve vrouw met een hart voor honden en dat merk
              je zeer goed. De tips helpen echt. Ik raad iedereen met puppy's,
              jongere hondjes en alle andere leeftijden deze cursus aan, vooral
              mensen die problemen hebben met hun troetel. Zowel
              gedragsproblemen als medische problemen. Volg even de gratis
              Masterclass en je bent volledig overtuigd van de cursus en de
              mensen erachter. Heel veel liefs aan iedereen van het team.
              Groetjes Tine Oetzmann
            </p>
          </div>
        </div>
        {/* Nicolette's Review */}
        <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-303">
          <div className="bg-gray-50 p-4 flex items-center justify-between" data-id="element-304">
            <div className="flex items-center" data-id="element-305">
              <div className="w-10 h-10 rounded-full bg-yellow-100 flex items-center justify-center text-gray-700 font-bold mr-3" data-id="element-306">
                NI
              </div>
              <div data-id="element-307">
                <div className="flex items-center" data-id="element-308">
                  <h3 className="font-bold mr-2" data-id="element-309">Nicolette</h3>
                  <span className="text-sm text-gray-500" data-id="element-310">2 reviews</span>
                  <span className="mx-2 text-gray-400" data-id="element-311">•</span>
                  <span className="text-sm text-gray-500" data-id="element-312">NL</span>
                </div>
                <div className="flex items-center" data-id="element-313">
                  {renderStars(5)}
                  <div className="ml-2 flex items-center text-gray-500 text-sm" data-id="element-314">
                    <CheckCircleIcon className="w-4 h-4 mr-1" data-id="element-315" />
                    Geverifieerd
                  </div>
                </div>
              </div>
            </div>
            <div className="text-gray-500" data-id="element-316">8 jul 2024</div>
          </div>
          <div className="p-4" data-id="element-317">
            <h4 className="font-bold text-lg mb-2" data-id="element-318">
              Hele fijne cursus. Aanrader zelfs voor de ervaren honden
              liefhebber.
            </h4>
            <p className="leading-relaxed mb-3" data-id="element-319">
              Nu hebben wij altijd herplaatsers, dus we zijn wel wat gewend.
              Maar bij onze laatste herplaatser hebben we wel hulp nodig.
            </p>
            <p className="leading-relaxed" data-id="element-320">
              Het is netjes overzichtelijk, duidelijk maar wat met het meeste
              aanspreekt is dat het zonder commando's gaat maar via
              communiceren.
            </p>
          </div>
        </div>
        {/* Smit's Review */}
        <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-321">
          <div className="bg-gray-50 p-4 flex items-center justify-between" data-id="element-322">
            <div className="flex items-center" data-id="element-323">
              <div className="w-10 h-10 rounded-full bg-purple-100 flex items-center justify-center text-gray-700 font-bold mr-3" data-id="element-324">
                SM
              </div>
              <div data-id="element-325">
                <div className="flex items-center" data-id="element-326">
                  <h3 className="font-bold mr-2" data-id="element-327">Smit</h3>
                  <span className="text-sm text-gray-500" data-id="element-328">11 reviews</span>
                  <span className="mx-2 text-gray-400" data-id="element-329">•</span>
                  <span className="text-sm text-gray-500" data-id="element-330">NL</span>
                </div>
                {renderStars(5)}
              </div>
            </div>
            <div className="text-gray-500" data-id="element-331">31 jul 2025</div>
          </div>
          <div className="p-4" data-id="element-332">
            <h4 className="font-bold text-lg mb-2" data-id="element-333">Laagdrempelige training</h4>
            <p className="leading-relaxed" data-id="element-334">
              Laagdrempelige training. De 1e tips heb ik direct toegepast. De
              masterclass was een eye-opener en het adaarop volgende aanbod is
              zeker de moeite waard.
            </p>
            <p className="text-right text-sm text-gray-500 mt-2" data-id="element-335">
              31 juli 2025
            </p>
          </div>
        </div>
      </div>
    </section>;
};